import { PlansHeaderRive } from '../../lumpsum-ui-components/PlansHeaderRive'

/** Flip this to swap header art. Call sites always use `HeaderRiveBackdrop`. */
const USE_SVG_HEADER_BACKDROP = true

type HeaderRiveBackdropProps = {
  isActive: boolean
  riveSrc: string
  headerSvgSrc: string
  backgroundColor: string
  /** When set, backdrop is clickable (allocation / ideal / SIP only). */
  onLandingCtaClick?: () => void
}

export function HeaderRiveBackdrop({
  isActive,
  riveSrc,
  headerSvgSrc,
  backgroundColor,
  onLandingCtaClick
}: HeaderRiveBackdropProps) {
  if (USE_SVG_HEADER_BACKDROP) {
    return (
      <HeaderSvgBackdropArt
        headerSvgSrc={headerSvgSrc}
        backgroundColor={backgroundColor}
        onLandingCtaClick={onLandingCtaClick}
      />
    )
  }

  return (
    <HeaderRiveBackdropArt
      isActive={isActive}
      riveSrc={riveSrc}
      backgroundColor={backgroundColor}
      onLandingCtaClick={onLandingCtaClick}
    />
  )
}

function HeaderRiveBackdropArt({
  isActive,
  riveSrc,
  backgroundColor,
  onLandingCtaClick
}: {
  isActive: boolean
  riveSrc: string
  backgroundColor: string
  onLandingCtaClick?: () => void
}) {
  const isClickable = onLandingCtaClick != null

  return (
    <div
      className={`absolute inset-y-0 right-0 z-0 overflow-visible ${isClickable ? 'cursor-pointer' : 'pointer-events-none'}`}
      aria-hidden={!isClickable}
      onClick={onLandingCtaClick}
    >
      <div
        data-plans-header-art=""
        className="absolute right-[-302px] top-[100px] h-[min(100%,420px)] w-[520px] min-h-[320px] -translate-y-1/2"
      >
        <PlansHeaderRive src={riveSrc} isActive={isActive} className="h-full w-full" />
        <HeaderBackdropColorWash backgroundColor={backgroundColor} />
      </div>
    </div>
  )
}

function HeaderSvgBackdropArt({
  headerSvgSrc,
  backgroundColor,
  onLandingCtaClick
}: {
  headerSvgSrc: string
  backgroundColor: string
  onLandingCtaClick?: () => void
}) {
  const isClickable = onLandingCtaClick != null

  return (
    <div
      className={`absolute inset-y-0 right-0 z-0 overflow-visible ${isClickable ? 'cursor-pointer' : 'pointer-events-none'}`}
      aria-hidden={!isClickable}
      onClick={onLandingCtaClick}
    >
      <div className="absolute 
      right-[-4px] min-[400px]:right-[0px] 
      top-[75px] min-[400px]:top-[85px] flex 
      h-[150px] min-[400px]:h-[170px] 
      w-[250px] min-[400px]:w-[260px] -translate-y-1/2 items-center justify-end">
        <img
          data-plans-header-art=""
          src={headerSvgSrc}
          alt=""
          className="block h-full w-auto max-w-none"
        />
        <HeaderBackdropColorWash backgroundColor={backgroundColor} />
      </div>
    </div>
  )
}

function HeaderBackdropColorWash({ backgroundColor }: { backgroundColor: string }) {
  return (
    <div
      className="pointer-events-none absolute inset-0 opacity-40"
      style={{
        background: `radial-gradient(circle at 40% 40%, transparent 35%, ${backgroundColor} 78%)`
      }}
      aria-hidden
    />
  )
}
